<template>

  <div id="app">

    <!--    <el-image :src="require('@/assets/img/top_bg.jpg')"-->
    <!--              style="z-index: -1;position: absolute;width: 100%;height: 40vh"></el-image>-->

    <el-container style="padding: 0;">
      <!--      <el-header class="topDiv">-->
      <div class="topDiv">

        <el-row>
          <el-col :span="3" :offset="3">
            <el-image :src="require('@/assets/img/logo.png')" style="height: 8vh"></el-image>
          </el-col>

          <el-col :span="18" class="navtop" style="margin-top: 1vh">

            <el-menu :default-active="defaultActive"
                     text-color="#000"
                     active-text-color="#D71634"
                     mode="horizontal"
                     router="true"
                     @select="handleSelect"
            >

              <el-menu-item index="/">{{ $t("Nav.sy") }}</el-menu-item>
              <el-sub-menu index="about">
                <template #title>{{ $t("Nav.gywm") }}</template>
                <el-menu-item index="/about/profil">{{ $t("Nav.gywm_gsjj") }}</el-menu-item>
                <!--                <el-menu-item index="/about/honors">{{ $t("Nav.gywm_gsry") }}</el-menu-item>-->
                <!--                <el-menu-item index="/about/vides">{{ $t("Nav.gywm_gssq") }}</el-menu-item>-->
                <!--                <el-menu-item index="/about/address">{{ $t("Nav.gywm_gswz") }}</el-menu-item>-->
                <el-menu-item index="/about/culture">{{ $t("Nav.gywm_qywh") }}</el-menu-item>
                <el-menu-item index="/about/responsibility">{{ $t("Nav.gywm_shzr") }}</el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="3">
                <template #title>{{ $t("Nav.cpyfw") }}</template>
                <el-menu-item index="/prduct/mulu">{{ $t("Nav.cpyfw_cpml") }}</el-menu-item>
                <el-menu-item index="/prduct/gongyiluxian">{{ $t("Nav.cpyfw_gylx") }}</el-menu-item>
                <el-menu-item index="/prduct/jishuchubei">{{ $t("Nav.cpyfw_jscb") }}</el-menu-item>
                <el-menu-item index="/prduct/zizhirenzheng">{{ $t("Nav.cpyfw_zzrz") }}</el-menu-item>
                <!--                <el-menu-item index="/prduct/hzhb">{{ $t("Nav.cpyfw_zlhzhb") }}</el-menu-item>-->
                <el-menu-item index="/prduct/yxwl">{{ $t("Nav.cpyfw_yxwl") }}</el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="4">
                <template #title>{{ $t("Nav.jsyf") }}</template>
                <el-menu-item index="/technology/team">{{ $t("Nav.jsyf_yfdw") }}</el-menu-item>
                <el-menu-item index="/technology/patent">{{ $t("Nav.jsyf_yqhz") }}</el-menu-item>
                <el-menu-item index="/technology/cooperation">{{ $t("Nav.jsyf_yfcg") }}</el-menu-item>
                <el-menu-item index="/technology/achievements">{{ $t("Nav.jsyf_zlbz") }}</el-menu-item>
              </el-sub-menu>

              <el-menu-item index="/news">{{ $t("Nav.xwzx") }}</el-menu-item>
<!--              <el-menu-item index="/environment">{{ $t("Nav.lshb") }}</el-menu-item>-->
              <el-sub-menu index="7" v-if="lanNow == 'zh'">
                <template #title>{{ $t("Nav.djyd") }}</template>
                <el-menu-item index="/part/study">{{ $t("Nav.djyd_xxyw") }}</el-menu-item>
                <el-menu-item index="/part/basic">{{ $t("Nav.djyd_jbgk") }}</el-menu-item>
                <el-menu-item index="/part/news">{{ $t("Nav.djyd_dqdt") }}</el-menu-item>
              </el-sub-menu>

              <el-menu-item index="/recruit">{{ $t("Nav.zpzx") }}</el-menu-item>
              <el-menu-item index="/contact">{{ $t("Nav.lxwm") }}</el-menu-item>

              <p @click="changeLan">{{ lan }}</p>
            </el-menu>


          </el-col>
          <el-col :span="2">

          </el-col>
        </el-row>
      </div>

      <!--      </el-header>-->
      <el-main style="padding: 0;min-height: 55vh;">
        <router-view/>
      </el-main>

      <el-footer style="padding: 0">

        <div class="footer">
          <el-row>
            <el-col :span="6" :offset="3">
              <el-image :src="require('@/assets/img/logo_bottom.png')"
                        style="margin-bottom:2vh"></el-image>
              <div class="footerBigText">{{ $t("home.pName") }}</div>
              <div class="footerNormalText">
                <span>{{ $t("home.dizhi") }}</span>
                <span>{{ $t("home.xsdh") }}</span>
                <span>{{ $t("home.xzdh") }}</span>
                <span>{{ $t("home.youbian") }}</span>
              </div>
            </el-col>
            <el-col :span="3" :offset="2">
              <div class="footerBigText" style="margin-top: 3vh">{{ $t("Nav.gywm") }}</div>
              <div class="footerNormalText">
                <p>
                  <el-link href="#/about/profil" :underline="false">{{ $t("Nav.gywm_gsjj") }}</el-link>
                </p>
                <p>
                  <el-link href="#/about/culture" :underline="false">{{ $t("Nav.gywm_qywh") }}</el-link>

                </p>
                <p>
                  <el-link href="#/about/responsibility" :underline="false">{{ $t("Nav.gywm_shzr") }}</el-link>
                </p>
              </div>

            </el-col>


            <el-col :span="3">
              <div class="footerBigText" style="margin-top: 3vh">{{ $t("Nav.cpyfw") }}</div>
              <div class="footerNormalText">
                <p>
                  <el-link href="#/prduct/mulu" :underline="false">{{ $t("Nav.cpyfw_cpml") }}</el-link>
                </p>
                <p>
                  <el-link href="#/prduct/jishuchubei" :underline="false">{{ $t("Nav.cpyfw_jscb") }}</el-link>
                </p>
                <p>
                  <el-link href="#/prduct/hzhb" :underline="false">{{ $t("Nav.cpyfw_zlhzhb") }}</el-link>
                </p>
              </div>
            </el-col>


            <el-col :span="4">

              <div >
                <div class="footerBigText"  style="margin-top: 3vh">{{ $t("Nav.wxgxh") }}</div>
                <div style="display: flex;justify-content: space-between" >
                  <div class="footerNormalText">
                     <div style="margin-bottom: 1vh ;width: 110px;text-align: center">{{ $t("Nav.wx_jljt") }}</div>
                     <el-image class="ewm" :src="require('@/assets/img/wx_jljt.jpg')" :fit="imgFit"></el-image>
                  </div>
                  <div class="footerNormalText" >
                    <div style="margin-bottom: 1vh;width: 110px;text-align: center">{{ $t("Nav.wx_cdjl") }}</div>
                    <el-image class="ewm" :src="require('@/assets/img/wx_cdjl.png')" :fit="imgFit"></el-image>
                  </div>

                </div>
              </div>


            </el-col>

            <div>
            </div>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="3">
              <div class="footerNormalText"
                   style="padding-top: 2vh;margin-top:2vh;display: flex;border-top-style:solid;border-width:1px;border-color: #fafafa;justify-content: space-between;">
                <span>{{ $t("home.bqsy") }}</span>

                <span style="font-size: 10px;margin-top: 4px;color: #f2f2f2">{{ $t("Comm.bah") }}</span>
                <span>
                  {{ $t("home.jszc") }}
                </span>
              </div>
            </el-col>


          </el-row>


        </div>

<!--        <div style="display:flex;justify-content: center">-->
<!--          <p class="footerSmallText">{{ $t("Nav.bah") }}</p>-->
<!--        </div>-->
      </el-footer>
    </el-container>

  </div>
</template>

<script setup>

import {useI18n} from "vue-i18n"
import {computed, ref} from "vue"
import {useRouter} from "vue-router"
import {useStore} from 'vuex' // 引入useStore 方法


const store = useStore()  // 该方法用于返回store 实例
const {locale} = useI18n()
import {onMounted} from 'vue'


const router = useRouter();
let lan = ref("EN")
let lanNow = computed(() => {
  return locale.value
})

function changeLan() {

  if (lan.value == "EN") {
    locale.value = 'en';
    lan.value = "中"
  } else {
    locale.value = 'zh';
    lan.value = "EN"
  }
}


function handleSelect(keyPath) {
  store.state.keyPath = keyPath;
}

onMounted(() => {
  console.log(`the component is now mounted.`)
  store.state.keyPath = sessionStorage.getItem('keyPath2') || '/'
})

const defaultActive = computed(() => {

  const path = router.currentRoute.value.path
  console.log("当前路由信息：" + path)
  if (store.state.keyPath && store.state.keyPath != '/') {
    sessionStorage.setItem('keyPath2', store.state.keyPath)
  }
  // return store.state.keyPath || '/'
  return path || '/'
})
</script>

<style>
/*#D71634*/
/*ff4d51*/
a {
  color: white !important;
}

a:hover {
  color: #D71634 !important;
}

.navtop ul {
  border: none;
  background-color: transparent;
}

element.style {
  /* --el-menu-item-hover-fill: antiquewhite; */

}

.navtop ul > li {
  color: #333;
  font-weight: bolder;
  font-size: 1rem;
  height: 50px;
  line-height: 50px;
  --el-menu-hover-bg-color: transparent;

  /*font-size: 13px;*/
  /*line-height: 18px;*/
  /*white-space: pre-line;*/
  /*text-align: center;*/
}

.navtop ul > li.is-opened {
  border-bottom: 2px solid #D71634;
}

.navtop ul > li.is-active {
  border-bottom: 2px solid #D71634 !important;
}

.navtop ul > li:hover {
  border-bottom: 2px solid #D71634 !important;
}

.navtop ul > li > div {
  color: #333;
  /*font-weight: bolder;*/
  /*font-size: 1.0rem;*/
  /*height: 50px;*/
  /*line-height: 50px;*/
  border-bottom: none !important;

  font-size: 1rem;
  line-height: 18px;
  white-space: pre-line;
  text-align: center;

}

.navtop ul > li > div:hover {
  background-color: initial !important;
}

/*.navtop ul>li.is-active>div {*/
/*  border-bottom: none;*/
/*}*/

/**/

.navtop ul > li > div > i {
  display: none;
}

.navtop ul ul > li.is-active {
  color: #D71634 !important;
}

.navtop ul ul > li:hover {
  color: #D71634 !important;
}

/*二级*/
ul.el-menu--popup {
  background-color: transparent !important;
}

ul.el-menu--popup li {
  float: left;
  margin-right: 30px;
  background-color: transparent !important;
  color: #333333 !important;
}

ul.el-menu--popup li.is-active {
  color: #D71634 !important;
}

ul.el-menu--popup li:hover {
  color: #D71634 !important;
  background-color: transparent !important;
}

.el-menu--horizontal.el-menu--popup-container {
  background-color: transparent !important;
}


/*ul.el-menu--popup li:hover{*/
/*  color: orangered;*/
/*}*/

html, body, #app, el-header, el-main, el-footer {
  margin: 0;
  padding: 0;
}

.topDiv {
  padding-top: 2vh;
  padding-bottom: 2vh;
}

.footer {
  background-image: url("assets/img/foot_bg.jpg");
  padding-top: 2vh;
  padding-bottom: 1vh;
  margin: 0;
  width: 100%;
}

.footerBigText {
  color: white;
  font-weight: bold;
  margin-bottom: 20px;
}

.footerNormalText {
  color: white;
  margin-bottom: 10px;
}


.footerSmallText {
  color: white;
  font-size: 10px;
  margin-bottom: 8px;
}

.footerNormalText span {
  display: flex;
  font-size: 14px;
  margin-bottom: 1vh;
}

.footerNormalText p {
  display: flex;
  font-size: 14px;
  margin-bottom: 2vh;
}

.ewm {
  width: 110px;
  height: 110px;
}
</style>
